import { Menu } from './../../util/menu';
import { Component, OnInit } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { BaseComponent } from './../../util/basecomponent';
import { PrincipalBaseComponent } from '../../util/PrincipalBaseComponent';
import { NoAuthorizationInterceptor } from 'src/app/util/interceptor/NoAuthorizationInterceptor';
import { UsuarioPublicService } from '../seguridad/usuario.public.service';
import { JWT_RESPONSE_HEADER } from '../seguridad/constantes';
import { SeguridadService } from '../seguridad/seguridad.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styles: []
})
export class LoginComponent extends PrincipalBaseComponent implements OnInit {

    usuario: string;
    contrasenia: string;
    comp: string;
    disableLogin: boolean;
    company: string = '';
    blok: Boolean = false;
    companias: SelectItem[] = [];
    verModalRecuperarClave: boolean = false;
    correoRecuperarClave: string = "";

    constructor(
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService,
        private service: UsuarioPublicService,
        private seguridadServicio: SeguridadService,
        private router: Router) {
        super(noAuthorizationInterceptor, messageService);
    }

    ngOnInit() {
        super.ngOnInit();
        sessionStorage.clear();
        localStorage.clear();
        this.disableLogin = false;
    }
    login(block?: any): void {
        block.blocked = true;
        this.bloquearPagina();

        this.disableLogin = true;

        this.service.login(this.usuario, this.contrasenia, this.company).then(
            obj => {
                block.blocked = false;

                if (obj != null) {
                    sessionStorage.setItem(JWT_RESPONSE_HEADER, obj.token);
                    this.seguridadServicio.obtenerUsuarioActual(this.usuario).then(
                        usuario => {
                            sessionStorage.setItem('ua', JSON.stringify(usuario));
                            localStorage.setItem('lang', 'es');
                            this.router.navigate(['royal']);
                        }
                    )
                }
            });
    }


    myMethod(event?: any, block?: any) {
        if (event.keyCode === 13) {
            this.login(block);
        }
    }

    // cargarCompaniasPorUsuario() {

    //     if (this.usuario == null) {
    //         this.companias = [];
    //         return;
    //     }

    //     this.bloquearPagina();
    //     this.service.listarCompanias(this.usuario)
    //         .then(
    //             res => {
    //                 this.companias = [];
    //                 res.forEach(obj => this.companias.push({ label: obj.nombre, value: obj.codigo }));
    //                 if (res.length > 0) {
    //                     this.company = res[0].codigo;
    //                 } else {
    //                     this.company = '';
    //                 }
    //                 this.desbloquearPagina();
    //             }
    //         );
    // }

    mostrarDialogRecuperarClave() {
        this.correoRecuperarClave = "";
        this.verModalRecuperarClave = true;
    }

    enviarRecuperarClave() {
        if (this.correoRecuperarClave == '' || this.correoRecuperarClave.trim() == '') {
            this.mostrarMensajeAdvertencia("Ingresar la cuenta de correo");
            return;
        }

        var regexp = new RegExp("^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$");
        var unit = true;

        unit = regexp.test(this.correoRecuperarClave);
        if (!unit) {
            this.mostrarMensajeAdvertencia("Ingresar una cuenta de correo válida");
            return;
        }

        this.bloquearPagina();
        // this.service.enviarRecuperarClave(this.correoRecuperarClave).then(
        //     res => {
        //         this.desbloquearPagina();
        //         if (res != null) {
        //             this.mostrarMensajeExito(res);
        //             this.verModalRecuperarClave = false;
        //             this.correoRecuperarClave = "";
        //         }
        //     }
        // );
    }
}
